import * as Mod1 from "./discourse-markdown/discourse-graphviz";
import * as Mod2 from "./discourse/api-initializers/discourse-graphviz";
import * as Mod3 from "./discourse/components/graphviz-diagram";
import * as Mod4 from "./discourse/components/graphviz-fullscreen";
import * as Mod5 from "./discourse/components/graphviz-inline";
import * as Mod6 from "./discourse/initializers/graphviz-admin-plugin-configuration-nav";
import * as Mod7 from "./discourse/lib/render-graphviz";
const compatModules = {
  "discourse-markdown/discourse-graphviz": Mod1,
  "discourse/api-initializers/discourse-graphviz": Mod2,
  "discourse/components/graphviz-diagram": Mod3,
  "discourse/components/graphviz-fullscreen": Mod4,
  "discourse/components/graphviz-inline": Mod5,
  "discourse/initializers/graphviz-admin-plugin-configuration-nav": Mod6,
  "discourse/lib/render-graphviz": Mod7,
};
export default compatModules;
